import React from 'react';
import withIcon from '../utilities/withIcon';

const IconArrowLeft = () => {
  return (
    <g>
      <path d="m15.2246 7.25h-12.6397l4.7593-4.76a.75.75 0 1 0 -1.0605-1.06l-6.0396 6.04a.7527.7527 0 0 0 0 1.0605l6.04 6.04a.75.75 0 1 0 1.0601-1.0605l-4.7593-4.76h12.64a.75.75 0 1 0 0-1.5z" />
    </g>
  );
};

export default withIcon(IconArrowLeft);
